import React, { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { loadUserFromStorage, logout as logoutAction } from '../store/slices/user-slice';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated: reduxIsAuthenticated, user, loading: reduxLoading } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);

  // Load user from cookies on mount
  useEffect(() => {
    const initAuth = async () => {
      setLoading(true);
      dispatch(loadUserFromStorage());
      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  const isAuthenticated = () => {
    const token = Cookies.get('artote_token');
    return reduxIsAuthenticated || !!token;
  };

  const logout = () => {
    dispatch(logoutAction());
  };

  const value = {
    user,
    isAuthenticated,
    loading: loading || reduxLoading,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
